import styles from './priceField.module.css'
import { InputGroup } from '../input-group/inputGroup'
import { Currency } from '../../../../../tables/types/types'
import { TextOrNumber } from '../../types'
import { O } from '../../../state/types'

type Props = {
    id: string
    inputKey?: string
    value?: number
    defaultValue?: number
    min?: number
    max?: number
    optional?: boolean
    disabled?: boolean
    thousandsSeparator?: boolean
    onChange?: (value?: number, manualChange?: boolean) => void
}

export const PriceField = (props: Props) => {
    const { id, inputKey, value, defaultValue, min = 0, max, optional, disabled, thousandsSeparator = true, onChange } = props

    const handleChange = (newValue?: TextOrNumber, manualChange?: boolean) => {
        onChange && onChange(newValue as O<number>, manualChange)
    }

    return (
        <InputGroup
            id={id}
            inputKey={inputKey}
            value={value}
            defaultValue={defaultValue}
            preLabel='$'
            postLabel={Currency.ARS}
            min={min}
            max={max}
            optional={optional}
            disabled={disabled}
            fit={true}
            thousandsSeparator={thousandsSeparator}
            className={styles.field}
            onChange={handleChange}
            aria-label={`${id} price field.`}
        />
    )
}
